export const ROUTE = {
  HOME: '/',
  REGISTER: '/register',
  COMPLETE: '/complete',
};
